module.exports = __webpack_public_path__ + "img/f14.6c701a3b.jpg";